// filepath: frontend/src/components/TableCellComponent.jsx
import React, { useEffect } from 'react';

function TableCellComponent({
  cellValue,
  isFrozen,
  tooltipData,
  cellKey,
  onCellChange,
  rowIndex,
  colIndex,
  hoveredTooltip,
  setHoveredTooltip,
  isAutoFilling,
  stickyStyle,
  isColumnSelected, // New prop
}) {
  const hasTooltip = tooltipData?.enabled && tooltipData?.text;
  const showTooltip = hoveredTooltip && hoveredTooltip.key === cellKey;

  const handleMouseEnter = () => {
    if (hasTooltip) {
      setHoveredTooltip({ key: cellKey, text: tooltipData.text });
    }
  };

  const handleMouseLeave = () => {
    setHoveredTooltip(null);
  };

  return (
    <td
      data-cell-key={cellKey}
      className={`relative px-6 py-2 text-base text-gray-700 align-top ${stickyStyle ? '' : 'min-w-[150px] w-[150px]'} ${
        (isFrozen || isAutoFilling) 
          ? 'bg-gray-100 text-gray-500 cursor-default'
          : isColumnSelected
          ? 'focus:outline-none focus:ring-2 focus:ring-blue-400 focus:bg-blue-100 hover:bg-blue-100'
          : 'focus:outline-none focus:ring-2 focus:ring-[#51c0a6] focus:bg-blue-50 hover:bg-gray-50'
      }`}
      style={stickyStyle}
      contentEditable={!isFrozen && !isAutoFilling}
      suppressContentEditableWarning={true}
      onBlur={(e) => !isFrozen && !isAutoFilling && onCellChange(rowIndex, colIndex, e.currentTarget.textContent)}
      onClick={(e) => e.stopPropagation()}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div className="flex items-center">
        {isAutoFilling ? (
          <div className="flex-1 flex items-center">
            <div className="animate-spin rounded-full h-4 w-4 border-2 border-gray-300 border-t-black mr-2"></div>
            <span className="text-gray-400">Generating...</span>
          </div>
        ) : (
          <span className="flex-1">{cellValue}</span>
        )}
      </div>
      {showTooltip && !isAutoFilling && (
        <div
          className="tooltip absolute z-10 px-3 py-2 text-sm font-medium text-white bg-gray-900 rounded-lg shadow-sm dark:bg-gray-700 transition-opacity duration-300 opacity-100"
          style={{
            top: '50%',
            left: '100%',
            transform: 'translateY(-50%) translateX(10px)',
            minWidth: '300px',
            pointerEvents: 'auto',
          }}
          onClick={(e) => e.stopPropagation()}
        >
          {tooltipData.text}
          <div className="tooltip-arrow" data-popper-arrow style={{
            position: 'absolute',
            top: '50%',
            right: '100%',
            transform: 'translateY(-50%)',
            width: '0',
            height: '0',
            borderTop: '5px solid transparent',
            borderBottom: '5px solid transparent',
            borderRight: '5px solid rgb(17 24 39 / var(--tw-bg-opacity))',
          }}></div>
        </div>
      )}
    </td>
  );
}

export default TableCellComponent;